import { render, staticRenderFns } from "./JourneyStatistics.vue?vue&type=template&id=c392aa82&"
import script from "./JourneyStatistics.vue?vue&type=script&lang=js&"
export * from "./JourneyStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c392aa82')) {
      api.createRecord('c392aa82', component.options)
    } else {
      api.reload('c392aa82', component.options)
    }
    module.hot.accept("./JourneyStatistics.vue?vue&type=template&id=c392aa82&", function () {
      api.rerender('c392aa82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/JourneyStatistics.vue"
export default component.exports